import _ from "lodash";

export const htmlToJson = (html: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const json = {};
    const itemList = [];

    _.forEach(doc.body.children, node => {
        parseNode(node, itemList);
    });

    return itemList;
}

const parseNode = (node, itemList, parentKey?, parentType?, first?, last?) => {
    const nodeKey = parentKey ? `${parentKey}-${node.nodeName}` : node.nodeName;
    const nodeValue = node.textContent.trim();

    if (!_.isEmpty(node.children)) {
        _.forEach(node.children, (childNode, index: number) => {
            let first, last;
            if (index === 0) {
                first = true
            } else if (index === node.children.length - 1) {
                last = true;
            }

            parseNode(childNode, itemList, nodeKey, node.localName, first, last);
        });
    } else if (nodeValue) {
        itemList.push({
            key: nodeKey,
            type: node.localName,
            text: nodeValue,
            html: node.outerHTML,
            parent: _.isEmpty(parentKey) ? '' : parentKey,
            parentType: _.isEmpty(parentType) ? '' : parentType,
            first: _.isEmpty(first) ? false : first,
            last: _.isEmpty(last) ? false : last
        });
    }

};
